export { default } from './PaginationItem';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/lab/esm/PaginationItem/index.js
// module id = 193
// module chunks = 0